import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  makeStyles,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Drawer,
  Chip,
  Collapse,
  FormControlLabel,
  Tooltip,
  CircularProgress,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import ArchiveIcon from '@material-ui/icons/Archive';
import DescriptionIcon from '@material-ui/icons/Description';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useSelector } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';

const useStyles = makeStyles(() => ({
  orangeFocused: {
    backgroundColor: "transparent",
    '& .MuiInputBase-input': {
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiInputLabel-root': {
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiFormHelperText-root': {
      fontSize: 'clamp(9px, 0.72vw, 11px)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor: '#FFFFFF',
    },
    '& .MuiSelect-selectMenu': {
      minHeight: 'unset !important',
      paddingTop: '10.5px',
      paddingBottom: '10.5px',
      lineHeight: 'normal',
      backgroundColor: "transparent",
    },
  },
  root: {
    background: "#f7faff",
    boxShadow: "0 6px 32px rgba(0,45,85,0.18)",
    borderRadius: 14,
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55",
    borderRadius: 50,
    border: 'none',
    boxShadow: 'none',
    border: '2px solid transparent',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    marginRight: 'clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: "#FF7F27",
    }
  },
  closeIconButton: {
    backgroundColor: '#e6eaf0',
    color: '#002D55',
    fontWeight: 'bold',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    borderRadius: 18,
    border: '2px solid transparent',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#FF7F27',
      border: '2px solid #FF7F27',
      boxShadow: 'none',
    },
  },
  card: {
    background: '#f7faff',
    borderRadius: 14,
  },
  cardContent: {
    background: '#f7faff',
    borderRadius: 8,
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: '12px 24px 24px 24px !important',
  },
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)',
    paddingLeft: 'clamp(5px, calc(2px + 0.625vw), 5px)',
  },
  cardHeaderRoot: {
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    padding: 'clamp(8px, calc(1px + 0.55vw), 12px) clamp(10px, calc(2px + 0.625vw), 16px)',
    boxSizing: 'border-box',
    borderBottom: '2px solid #FF7F27',
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
    },
    '& .MuiCardHeader-title': {
      fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)',
      fontWeight: 700,
      color: '#002D55',
      lineHeight: 1.2,
    },
  },
  bodyText: {
    color: "#666666",
    marginBottom: 'clamp(8px, 0.78vw, 12px)',
    fontSize: 'clamp(12px, 1vw, 15px)',
  },
  input: {},
  statsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 'clamp(12px, 1.04vw, 16px)',
    marginTop: 'clamp(12px, 1.04vw, 16px)',
    padding: 'clamp(8px, 0.78vw, 12px)',
    backgroundColor: "#E3F2FD",
    borderRadius: 8,
  },
  statItem: {
    flex: 1,
    textAlign: 'center',
  },
  statLabel: {
    fontSize: 'clamp(11px, 0.9vw, 14px)',
    color: "#666666",
    fontWeight: '600',
    marginBottom: 'clamp(3px, 0.26vw, 4px)',
  },
  statValue: {
    fontSize: 'clamp(12px, 1vw, 16px)',
    color: "#002D55",
    fontWeight: 'bold',
  },
  accordionTitle: {
    color: "#002D55",
    fontWeight: '600',
    fontSize: 'clamp(12px, 0.9vw, 14px)',
  },
  addButton: {
    backgroundColor: "#002D55",
    color: "#FFFFFF",
    borderRadius: 12,
    marginRight: 'clamp(6px, 0.52vw, 8px)',
    marginLeft: 'clamp(6px, 0.52vw, 8px)',
    '&:hover': {
      backgroundColor: "#001a3a",
    }
  },
  insuranceTab: {
    textTransform: 'none',
    borderRadius: 8,
    minHeight: 'clamp(36px, 3.13vw, 48px)',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    color: '#002D55',
    fontWeight: 600,
    fontSize: 'clamp(12px, 0.85vw, 14px)',
    backgroundColor: '#FFFFFF',
    '&.MuiTab-root': {
      minHeight: 'clamp(36px, 3.13vw, 48px)',
    },
    '&.MuiTab-labelIcon': {
      minHeight: 'clamp(36px, 3.13vw, 48px)',
      paddingTop: 'clamp(4px, 0.39vw, 6px)',
    },
    '&$selected': {
      color: '#002D55',
      backgroundColor: '#FFFFFF',
    },
    '&.Mui-selected': {
      color: '#002D55',
    },
    '&:hover': {
      color: '#FF7F27',
    },
  },
  addInlineTab: {
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiTab-iconWrapper': {
      marginBottom: 0,
      marginRight: 'clamp(4px, 0.39vw, 6px)',
    },
  },
  selected: {},
  tabsWrapper: {
    borderRadius: 12,
    overflow: 'visible',
    '&:hover $tabsIndicator': {
      backgroundColor: '#002D55',
    },
  },
  tabsFlexContainer: {
    gap: 'clamp(6px, 0.52vw, 8px)',
    paddingRight: 'clamp(6px, 0.52vw, 8px)',
  },
  tabsIndicator: {
    backgroundColor: '#FF7F27',
    height: 3,
  },
  selectedReferralItem: {
    backgroundColor: '#E3F2FD',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BBDEFB',
    }
  },
  referralDetailsCard: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: 8,
    padding: 'clamp(12px, 1.04vw, 16px)',
    marginTop: 'clamp(12px, 1.04vw, 16px)',
  },
  removeButton: {
    backgroundColor: '#d32f2f',
    color: '#FFFFFF',
    borderRadius: 6,
    padding: 'clamp(3px, 0.26vw, 4px) clamp(6px, 0.52vw, 8px)',
    fontSize: 'clamp(10px, 0.78vw, 12px)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#b71c1c',
    }
  },
  referralDropdown: {
    borderRadius: 14,
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      color: '#002D55',
      fontWeight: 600,
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ddd',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiSelect-root[aria-expanded="true"] ~ .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
  },
  selectSmall: {
    '& .MuiSelect-selectMenu': {
      paddingTop: '8.5px !important',
      paddingBottom: '8.5px !important',
    },
    '& .MuiSelect-select.MuiSelect-outlined': {
      paddingTop: '10px !important',
      paddingBottom: '10px !important',
    },
  },
}));

const SelectedPatientInsurance = ({
  className,
  selectedPatient,
  treatments = [],
  appointments: appointmentsProp = [],
  selectedTreatmentId,
  onTreatmentChange,
  headerTabs,
  headerTitle = 'Insurance',
  ...rest
}) => {
  const classes = useStyles();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const backendBaseUrl = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';

  const normalizeProviderName = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  
  // Multi-insurance support with tabs
  const [insuranceRecords, setInsuranceRecords] = useState([]);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [showInsuranceFields, setShowInsuranceFields] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showAddReferralForm, setShowAddReferralForm] = useState(false);
  const [usageDrawerOpen, setUsageDrawerOpen] = useState(false);
  const [allAppointments, setAllAppointments] = useState([]);
  const [referralInvoices, setReferralInvoices] = useState([]);
  const [invoicesDrawerTab, setInvoicesDrawerTab] = useState(0);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [showInlinePolicyPanel, setShowInlinePolicyPanel] = useState(false);
  const [showUploadSection, setShowUploadSection] = useState({});
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [viewingDocument, setViewingDocument] = useState(null);
  const [viewingDocumentName, setViewingDocumentName] = useState('');
  const [documentQrOpen, setDocumentQrOpen] = useState(false);
  const [documentQrConfig, setDocumentQrConfig] = useState({ target: 'policy', title: 'Insurance Policy' });

  // Clinic-level insurer agreements for linking
  const [clinicAgreements, setClinicAgreements] = useState([]);

  const patientId = selectedPatient?.user_id
    || selectedPatient?.id
    || selectedPatient?.user?.id
    || selectedPatient?.patient_id
    || (user && (user.id || user.user_id || user.userId || user.uuid));
  const careProviderId = user?.care_provider_unit?.id || user?.care_provider?.id || user?.careProvider?.id || user?.id || '';

  const getProviderDetailsSnapshot = (insurance = {}) => ({
    provider: String(insurance.provider || '').trim(),
    billingEmail: String(insurance.billingEmail || '').trim(),
    planType: String(insurance.planType || '').trim(),
    policyNumber: String(insurance.policyNumber || '').trim(),
    memberId: String(insurance.memberId || '').trim(),
    groupNumber: String(insurance.groupNumber || '').trim(),
    agreementId: String(insurance.agreementId || ''),
  });

  const getDuplicateInsurances = (referenceInsurance, records = insuranceRecords) => {
    const providerName = normalizeProviderName(referenceInsurance?.provider);
    if (!providerName) {
      return [];
    }

    return (records || []).filter((insurance) => {
      if (!insurance || insurance.id === referenceInsurance?.id) {
        return false;
      }
      return normalizeProviderName(insurance.provider) === providerName;
    });
  };

  // Helper functions for multi-insurance management
  const getCurrentInsurance = () => {
    if (!insuranceRecords || insuranceRecords.length === 0) {
      return {
        id: null,
        provider: '',
        billingEmail: '',
        planType: '',
        policyNumber: '',
        memberId: '',
        groupNumber: '',
        approvedTreatments: '',
        totalCostAmount: '',
        coverageValidFrom: '',
        coverageValidUntil: '',
        referralNotes: '',
        referralLetters: [],
        activeReferralLetterIds: [],
        activeReferralLetterId: '',
        newReferralId: '',
        newReferralTitle: '',
        newReferralValidFrom: '',
        newReferralValidUntil: '',
        newReferralPolicyNumber: '',
        newReferralMemberId: '',
        newReferralGroupNumber: '',
        newReferralApprovedTreatments: '',
        newReferralApprovedAmount: '',
        newReferralPolicyEvidenceFile: null,
        newReferralPolicyEvidenceFileName: '',
        creatingReferral: false,
        policyEvidenceFile: null,
        policyEvidenceFileName: '',
        isPendingReview: false,
        pendingReason: '',
        agreementId: '',
      };
    }

    return insuranceRecords[currentTabIndex] || insuranceRecords[0];
  };

  const updateCurrentInsurance = (field, value) => {
    setInsuranceRecords((prev) => {
      const updated = [...prev];
      if (updated[currentTabIndex]) {
        updated[currentTabIndex] = {
          ...updated[currentTabIndex],
          [field]: value,
        };
      }
      return updated;
    });
  };

  const addNewInsurance = () => {
    const newInsurance = {
      id: null,
      provider: '',
      billingEmail: '',
      planType: '',
      policyNumber: '',
      memberId: '',
      groupNumber: '',
      approvedTreatments: '',
      totalCostAmount: '',
      coverageValidFrom: '',
      coverageValidUntil: '',
      referralNotes: '',
      referralLetters: [],
      activeReferralLetterIds: [],
      activeReferralLetterId: '',
      newReferralId: '',
      newReferralTitle: '',
      newReferralValidFrom: '',
      newReferralValidUntil: '',
      newReferralPolicyNumber: '',
      newReferralMemberId: '',
      newReferralGroupNumber: '',
      newReferralApprovedTreatments: '',
      newReferralApprovedAmount: '',
      newReferralPolicyEvidenceFile: null,
      newReferralPolicyEvidenceFileName: '',
      creatingReferral: false,
      policyEvidenceFile: null,
      policyEvidenceFileName: '',
      isPendingReview: false,
      pendingReason: '',
      agreementId: '',
      isNew: true,
    };
    newInsurance.providerDetailsBaseline = getProviderDetailsSnapshot(newInsurance);
    setInsuranceRecords((prev) => [...prev, newInsurance]);
    setCurrentTabIndex(insuranceRecords.length);
    setShowInsuranceFields(true);
  };

  const deleteInsurance = async (index) => {
    const insurance = insuranceRecords[index];
    if (insurance && insurance.id) {
      if (!window.confirm('Are you sure you want to delete this insurance record?')) {
        return;
      }
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${insurance.id}/`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error('Failed to delete insurance');
        }
      } catch (error) {
        console.error('Failed to delete insurance:', error);
        alert('Failed to delete insurance record.');
        return;
      }
    }
    
    setInsuranceRecords((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      return updated;
    });
    
    if (currentTabIndex >= index && currentTabIndex > 0) {
      setCurrentTabIndex(currentTabIndex - 1);
    }
    
    if (insuranceRecords.length === 1) {
      setShowInsuranceFields(false);
    }
  };

  const currentIns = getCurrentInsurance();
  const duplicateInsurances = getDuplicateInsurances(currentIns);
  const policyEvidencePreviewSrc = currentIns.policyEvidenceFile
    ? (String(currentIns.policyEvidenceFile).startsWith('data:')
      ? currentIns.policyEvidenceFile
      : `data:application/pdf;base64,${currentIns.policyEvidenceFile}`)
    : '';
  const currentProviderDetailsSnapshot = getProviderDetailsSnapshot(currentIns);
  const providerDetailsBaseline = currentIns.providerDetailsBaseline || getProviderDetailsSnapshot();
  const showProviderDetailsSaveButton = JSON.stringify(currentProviderDetailsSnapshot) !== JSON.stringify(providerDetailsBaseline);
  const [insurancePolicyConfirmed, setInsurancePolicyConfirmed] = useState(false);
  const [referralLetterConfirmed, setReferralLetterConfirmed] = useState(false);
  const [referralSubTab, setReferralSubTab] = useState(0);
  const [selectedReferralId, setSelectedReferralId] = useState(null);

  useEffect(() => {
    setInsurancePolicyConfirmed(false);
    setReferralLetterConfirmed(false);
  }, [currentIns.id]);

  const isReferralExpired = (letter) => {
    if (!letter) return false;
    if (String(letter.status || '').toLowerCase() === 'expired') return true;
    if (!letter.valid_until) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const validUntil = new Date(letter.valid_until);
    validUntil.setHours(0, 0, 0, 0);
    return validUntil < today;
  };

  const getShortDocumentLabel = (referral) => {
    const label = referral.title || referral.referral_id || 'Document';
    if (label.length > 30) {
      return '...' + label.slice(-27); // 3 dots + 27 chars = 30 total
    }
    return label;
  };

  const buildDocumentCaptureUrl = (target, referral = null) => {
    if (typeof window === 'undefined') {
      return '';
    }

    const url = new URL(window.location.href);
    if (patientId) {
      url.searchParams.set('patientId', String(patientId));
    }
    if (currentIns?.id) {
      url.searchParams.set('insuranceId', String(currentIns.id));
    }
    url.searchParams.set('uploadTarget', target);
    if (referral?.id) {
      url.searchParams.set('referralId', String(referral.id));
    }
    if (referral?.referral_id) {
      url.searchParams.set('referralNumber', String(referral.referral_id));
    }
    return url.toString();
  };

  const openDocumentQr = (target, referral = null) => {
    setDocumentQrConfig({
      target,
      title: target === 'referral'
        ? `Referral ${referral?.referral_id || referral?.title || 'Document'}`
        : 'Insurance Policy',
    });
    setDocumentQrOpen(true);
  };

  const handleRemoveReferralLetter = async (letterId) => {
    if (!window.confirm('Are you sure you want to remove this referral letter?')) {
      return;
    }
    try {
      const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/referral-letters/${letterId}/`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      if (response.ok) {
        setInsuranceRecords((prev) => {
          const updated = [...prev];
          if (updated[currentTabIndex]) {
            updated[currentTabIndex] = {
              ...updated[currentTabIndex],
              referralLetters: updated[currentTabIndex].referralLetters.filter((r) => r.id !== letterId),
            };
          }
          return updated;
        });
        if (selectedReferralId === letterId) {
          setSelectedReferralId(null);
        }
      } else {
        alert('Failed to remove referral letter');
      }
    } catch (error) {
      console.error('Error removing referral letter:', error);
      alert('Error removing referral letter');
    }
  };

  const currentReferralLetters = currentIns.referralLetters.filter((letter) => !isReferralExpired(letter));
  const previousReferralLetters = currentIns.referralLetters.filter((letter) => isReferralExpired(letter));

  // Update selected referral's policy details
  const updateSelectedReferralPolicyDetail = (field, value) => {
    setInsuranceRecords((prev) => {
      const updated = [...prev];
      if (updated[currentTabIndex] && updated[currentTabIndex].referralLetters) {
        updated[currentTabIndex] = {
          ...updated[currentTabIndex],
          referralLetters: updated[currentTabIndex].referralLetters.map((letter) => {
            if (letter.id === selectedReferralId) {
              return { ...letter, [field]: value };
            }
            return letter;
          })
        };
      }
      return updated;
    });
  };

  // Auto-select the latest referral letter
  useEffect(() => {
    const lettersToCheck = referralSubTab === 0 ? currentReferralLetters : previousReferralLetters;
    
    if (lettersToCheck && lettersToCheck.length > 0) {
      const latestLetter = lettersToCheck[0];
      if (!selectedReferralId || !lettersToCheck.find(l => l.id === selectedReferralId)) {
        setSelectedReferralId(latestLetter.id);
      }
    } else {
      setSelectedReferralId(null);
    }
  }, [currentIns.referralLetters, selectedReferralId, referralSubTab]);

  const selectedReferral = currentIns.referralLetters?.find((l) => l.id === selectedReferralId);
  const referralScanStatus = String(selectedReferral?.upload_status || '').toLowerCase();
  const isReferralScanInProgress = referralScanStatus === 'pending' || referralScanStatus === 'scanning';
  const isReferralScanRejected = referralScanStatus === 'rejected' || referralScanStatus === 'failed';
  const newReferralDocumentScanStatus = String(currentIns.newReferralDocumentUploadStatus || '').toLowerCase();
  const isNewReferralDocumentScanInProgress = newReferralDocumentScanStatus === 'pending' || newReferralDocumentScanStatus === 'scanning';
  const isNewReferralDocumentScanRejected = newReferralDocumentScanStatus === 'rejected' || newReferralDocumentScanStatus === 'failed';
  const isReferralCreateBlocked = Boolean(currentIns.newReferralDocumentUploadId && newReferralDocumentScanStatus !== 'clean');
  const policyScanStatus = String(currentIns.policyEvidenceUploadStatus || '').toLowerCase();
  const isPolicyScanInProgress = policyScanStatus === 'pending' || policyScanStatus === 'scanning';
  const isPolicyScanRejected = policyScanStatus === 'rejected' || policyScanStatus === 'failed';
  const isPolicySaveBlocked = isPolicyScanInProgress || isPolicyScanRejected
    || Boolean(currentIns.policyEvidenceUploadId && policyScanStatus !== 'clean');
  const hasPolicyAwaitingSave = !currentIns.id && currentIns.policyEvidenceUploadId && policyScanStatus === 'clean';
  const pendingPolicyInsuranceIds = insuranceRecords
    .filter((insurance) => insurance.id && ['pending', 'scanning'].includes(String(insurance.policyEvidenceUploadStatus || '').toLowerCase()))
    .map((insurance) => insurance.id)
    .join(',');
  const pendingPolicyPreScanIds = insuranceRecords
    .filter((insurance) => !insurance.id && insurance.policyEvidenceUploadId
      && ['pending', 'scanning'].includes(String(insurance.policyEvidenceUploadStatus || '').toLowerCase()))
    .map((insurance) => insurance.policyEvidenceUploadId)
    .join(',');
  const pendingReferralInsuranceIds = insuranceRecords
    .filter((insurance) => insurance.id && insurance.referralLetters?.some((letter) => {
      const scanStatus = String(letter.upload_status || '').toLowerCase();
      return scanStatus === 'pending' || scanStatus === 'scanning';
    }))
    .map((insurance) => insurance.id)
    .join(',');

  // Fetch clinic-level insurer agreements for the link dropdown
  useEffect(() => {
    if (!token || !backendBaseUrl) return;
    const fetchAgreements = async () => {
      try {
        const res = await fetch(`${backendBaseUrl}/profile/clinic/insurance-agreements/`, {
          headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        });
        if (res.ok) {
          const data = await res.json();
          setClinicAgreements(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error('Failed to load clinic agreements:', err);
      }
    };
    fetchAgreements();
  }, [backendBaseUrl, token]);
  
  // Fetch insurance and referral letters on component mount
  useEffect(() => {
    if (!token || !patientId) return;

    let mounted = true;

    const fetchReferralLetters = async (insuranceRecordId, preselectedActiveId = '') => {
      if (!insuranceRecordId) {
        return [];
      }
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${insuranceRecordId}/referral-letters/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error(`Failed to load referral letters (${response.status})`);
        }
        const letters = await response.json();
        return Array.isArray(letters) ? letters : [];
      } catch (error) {
        console.error('Failed to load referral letters:', error);
        return [];
      }
    };

    const fetchInsurance = async () => {
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!mounted) return;

        if (response.status === 404) {
          setInsuranceRecords([{
            id: null, provider: '', billingEmail: '', planType: '', policyNumber: '',
            memberId: '', groupNumber: '', approvedTreatments: '', totalCostAmount: '',
            coverageValidFrom: '', coverageValidUntil: '', referralNotes: '',
            referralLetters: [], activeReferralLetterIds: [], activeReferralLetterId: '',
            newReferralId: '', newReferralTitle: '', newReferralValidFrom: '', newReferralValidUntil: '',
            newReferralPolicyNumber: '', newReferralMemberId: '', newReferralGroupNumber: '',
            newReferralApprovedTreatments: '', newReferralApprovedAmount: '',
            newReferralPolicyEvidenceFile: null, newReferralPolicyEvidenceFileName: '',
            creatingReferral: false, policyEvidenceFile: null, policyEvidenceFileName: '',
            isPendingReview: false, pendingReason: '', reviewNotes: '', reviewedAt: '', reviewedByName: '', isPrimary: false, isActive: true, agreementId: '', isNew: true,
          }]);
          setCurrentTabIndex(0);
          setShowInsuranceFields(true);
          return;
        }

        if (!response.ok) {
          throw new Error(`Failed to load insurance (${response.status})`);
        }

        const data = await response.json();
        const insuranceList = Array.isArray(data) ? data : (data?.results || (data ? [data] : []));

        if (!insuranceList || insuranceList.length === 0) {
          setInsuranceRecords([{
            id: null, provider: '', billingEmail: '', planType: '', policyNumber: '',
            memberId: '', groupNumber: '', approvedTreatments: '', totalCostAmount: '',
            coverageValidFrom: '', coverageValidUntil: '', referralNotes: '',
            referralLetters: [], activeReferralLetterIds: [], activeReferralLetterId: '',
            newReferralId: '', newReferralTitle: '', newReferralValidFrom: '', newReferralValidUntil: '',
            newReferralPolicyNumber: '', newReferralMemberId: '', newReferralGroupNumber: '',
            newReferralApprovedTreatments: '', newReferralApprovedAmount: '',
            newReferralPolicyEvidenceFile: null, newReferralPolicyEvidenceFileName: '',
            creatingReferral: false, policyEvidenceFile: null, policyEvidenceFileName: '',
            isPendingReview: false, pendingReason: '', reviewNotes: '', reviewedAt: '', reviewedByName: '', isPrimary: false, isActive: true, agreementId: '', isNew: true,
          }]);
          setCurrentTabIndex(0);
          setShowInsuranceFields(true);
          return;
        }

        // Load all insurance records with their referral letters
        const recordsWithLetters = await Promise.all(
          insuranceList.map(async (ins) => {
            const letters = await fetchReferralLetters(ins.id);
            const selectedActiveId = ins.active_referral_letter
              ? String(ins.active_referral_letter)
              : (ins.active_referral_letter_details?.id ? String(ins.active_referral_letter_details.id) : '');
            
            const mappedInsurance = {
              id: ins.id,
              provider: ins.insurance_provider || '',
              billingEmail: ins.billing_email || '',
              planType: ins.plan_type || '',
              policyNumber: ins.policy_number || '',
              memberId: ins.member_id || '',
              groupNumber: ins.group_number || '',
              approvedTreatments: ins.approved_treatments == null ? '' : String(ins.approved_treatments),
              totalCostAmount: ins.total_cost_amount == null ? '' : String(ins.total_cost_amount),
              coverageValidFrom: ins.coverage_valid_from || '',
              coverageValidUntil: ins.coverage_valid_until || '',
              referralNotes: ins.referral_notes || '',
              policyEvidenceFile: ins.policy_evidence_file || null,
              policyEvidenceFileName: ins.policy_evidence_file ? 'policy_document.pdf' : '',
              policyEvidenceUploadStatus: ins.policy_evidence_upload_status || '',
              isPendingReview: ins.is_pending_review || false,
              pendingReason: ins.pending_reason || '',
              reviewNotes: ins.review_notes || '',
              reviewedAt: ins.reviewed_at || '',
              reviewedByName: ins.reviewed_by_name || '',
              isPrimary: ins.is_primary || false,
              isActive: ins.is_active !== false,
              agreementId: ins.agreement || '',
              referralLetters: letters,
              activeReferralLetterIds: letters
                .filter((letter) => letter.is_active !== false && !isReferralExpired(letter))
                .map((letter) => String(letter.id)),
              activeReferralLetterId: selectedActiveId,
              newReferralId: '',
              newReferralTitle: '',
              newReferralValidFrom: '',
              newReferralValidUntil: '',
              newReferralPolicyNumber: '',
              newReferralMemberId: '',
              newReferralGroupNumber: '',
              newReferralApprovedTreatments: '',
              newReferralApprovedAmount: '',
              creatingReferral: false,
            };
            return {
              ...mappedInsurance,
              providerDetailsBaseline: getProviderDetailsSnapshot(mappedInsurance),
            };
          })
        );

        setInsuranceRecords(recordsWithLetters);
        setShowInsuranceFields(true);
      } catch (error) {
        console.error('Failed to load insurance details:', error);
      }
    };

    fetchInsurance();

    return () => {
      mounted = false;
    };
  }, [backendBaseUrl, token, patientId]);

  useEffect(() => {
    if (!token || !pendingPolicyInsuranceIds) return undefined;

    let cancelled = false;
    const insuranceIds = pendingPolicyInsuranceIds.split(',').filter(Boolean);
    const refreshPolicyScans = async () => {
      const results = await Promise.all(insuranceIds.map(async (insuranceId) => {
        try {
          const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/${insuranceId}/`, {
            headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
          });
          return response.ok ? [insuranceId, await response.json()] : [insuranceId, null];
        } catch (error) {
          console.error('Failed to refresh policy scan status:', error);
          return [insuranceId, null];
        }
      }));
      if (cancelled) return;

      const recordsById = new Map(results.filter(([, record]) => record));
      setInsuranceRecords((previous) => previous.map((insurance) => {
        const record = recordsById.get(insurance.id);
        return record ? {
          ...insurance,
          policyEvidenceFile: record.policy_evidence_file || null,
          policyEvidenceFileName: record.policy_evidence_file ? 'policy_document.pdf' : insurance.policyEvidenceFileName,
          policyEvidenceUploadStatus: record.policy_evidence_upload_status || '',
        } : insurance;
      }));
    };

    refreshPolicyScans();
    const pollId = window.setInterval(refreshPolicyScans, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, pendingPolicyInsuranceIds]);

  useEffect(() => {
    if (!token || !pendingPolicyPreScanIds) return undefined;

    let cancelled = false;
    const uploadIds = pendingPolicyPreScanIds.split(',').filter(Boolean);
    const refreshPreScans = async () => {
      const results = await Promise.all(uploadIds.map(async (uploadId) => {
        try {
          const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/policy-evidence/pre-scan/${uploadId}/`, {
            headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
          });
          return response.ok ? [uploadId, await response.json()] : [uploadId, null];
        } catch (error) {
          console.error('Failed to refresh policy pre-scan status:', error);
          return [uploadId, null];
        }
      }));
      if (cancelled) return;

      const statusById = new Map(results.filter(([, upload]) => upload).map(([uploadId, upload]) => [uploadId, upload.status]));
      setInsuranceRecords((previous) => previous.map((insurance) => (
        statusById.has(insurance.policyEvidenceUploadId)
          ? { ...insurance, policyEvidenceUploadStatus: statusById.get(insurance.policyEvidenceUploadId) }
          : insurance
      )));
    };

    refreshPreScans();
    const pollId = window.setInterval(refreshPreScans, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, pendingPolicyPreScanIds]);

  useEffect(() => {
    if (!token || !currentIns.newReferralDocumentUploadId || !isNewReferralDocumentScanInProgress) return undefined;

    let cancelled = false;
    const refreshReferralPreScan = async () => {
      try {
        const response = await fetch(
          `${backendBaseUrl}/profile/patient/insurance/referral-documents/pre-scan/${currentIns.newReferralDocumentUploadId}/`,
          { headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' } }
        );
        if (!response.ok || cancelled) return;
        const upload = await response.json();
        updateCurrentInsurance('newReferralDocumentUploadStatus', upload.status);
      } catch (error) {
        console.error('Failed to refresh referral document scan status:', error);
      }
    };

    refreshReferralPreScan();
    const pollId = window.setInterval(refreshReferralPreScan, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, currentIns.newReferralDocumentUploadId, isNewReferralDocumentScanInProgress]);

  useEffect(() => {
    if (!token || !patientId || !pendingReferralInsuranceIds) return undefined;

    let cancelled = false;
    const insuranceIds = pendingReferralInsuranceIds.split(',').filter(Boolean);
    const refreshReferralScans = async () => {
      const scanResults = await Promise.all(insuranceIds.map(async (insuranceId) => {
        try {
          const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${insuranceId}/referral-letters/`, {
            headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
          });
          return response.ok ? [insuranceId, await response.json()] : [insuranceId, null];
        } catch (error) {
          console.error('Failed to refresh referral scan status:', error);
          return [insuranceId, null];
        }
      }));
      if (cancelled) return;

      const lettersByInsuranceId = new Map(scanResults.filter(([, letters]) => Array.isArray(letters)));
      if (!lettersByInsuranceId.size) return;
      setInsuranceRecords((previous) => previous.map((insurance) => (
        lettersByInsuranceId.has(insurance.id)
          ? { ...insurance, referralLetters: lettersByInsuranceId.get(insurance.id) }
          : insurance
      )));
    };

    refreshReferralScans();
    const pollId = window.setInterval(refreshReferralScans, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, patientId, pendingReferralInsuranceIds]);

  // Helper functions for appointment filtering
  const isUsageEligibleStatus = (status) => {
    const normalized = String(status || '').toLowerCase();
    return normalized !== 'cancelled' && normalized !== 'no_show' && normalized !== 'no-show';
  };

  const isInsurancePayer = (appointment) => {
    const payerType = String(appointment?.payer_type || '').toLowerCase();
    const payerAlias = String(appointment?.payer || appointment?.billing_payer || appointment?.payment_responsibility || '').toLowerCase();
    return appointment?.insurance_paid === true || payerType === 'insurance' || payerAlias === 'insurance' || payerAlias === 'insurer';
  };

  const extractAppointmentReferralId = (appointment) => {
    if (appointment?.payer_referral_letter && typeof appointment.payer_referral_letter === 'string') {
      return appointment.payer_referral_letter;
    }
    if (appointment?.payer_referral_letter?.id) {
      return appointment.payer_referral_letter.id;
    }
    return '';
  };

  // Function to refresh appointment usage data
  const refreshAppointmentUsage = async () => {
    if (!token || !patientId || !backendBaseUrl) return;
    
    try {
      const response = await fetch(`${backendBaseUrl}/api/calendar/appointments/`, {
        headers: { 'Authorization': `Token ${token}` },
      });
      if (!response.ok) return;
      const data = await response.json();
      const appointmentList = data.appointments || (Array.isArray(data) ? data : data.results || []);
      
      // Store all appointments for drawer display
      setAllAppointments(appointmentList);
      
      // Update usage for each insurance record
      setInsuranceRecords((prev) => {
        return prev.map((ins) => {
          const insuranceAppointments = appointmentList.filter((apt) => {
            if (!isUsageEligibleStatus(apt?.status)) return false;
            if (!isInsurancePayer(apt)) return false;

            const appointmentReferralId = extractAppointmentReferralId(apt);
            const activeIds = Array.isArray(ins.activeReferralLetterIds)
              ? ins.activeReferralLetterIds.filter(Boolean).map(String)
              : [];

            if (activeIds.length > 0) {
              return activeIds.includes(String(appointmentReferralId));
            }

            if (ins.activeReferralLetterId) {
              return String(appointmentReferralId) === String(ins.activeReferralLetterId);
            }
            return true;
          });
          const usedCount = insuranceAppointments.length;
          const totalAmount = insuranceAppointments.reduce((sum, apt) => (
            sum + (apt.booked_price ? Number(apt.booked_price) : 0)
          ), 0);

          return {
            ...ins,
            usedTreatments: String(usedCount),
            usedCostAmount: totalAmount.toFixed(2),
          };
        });
      });
    } catch (error) {
      console.error('Failed to load appointments for insurance usage:', error);
    }
  };

  // Load appointment usage on mount only
  useEffect(() => {
    refreshAppointmentUsage();
  }, [backendBaseUrl, token, patientId]);

  // Fetch invoices when drawer opens or referral changes
  useEffect(() => {
    if (usageDrawerOpen && selectedReferral?.id) {
      fetchReferralInvoices(selectedReferral.id);
    }
  }, [usageDrawerOpen, selectedReferral?.id, token, backendBaseUrl, patientId]);

  const fetchReferralInvoices = async (referralId) => {
    if (!token || !patientId || !referralId) {
      setReferralInvoices([]);
      return;
    }
    
    setLoadingInvoices(true);
    try {
      const response = await fetch(`${backendBaseUrl}/api/calendar/invoices/`, {
        headers: { 'Authorization': `Token ${token}` },
      });
      if (!response.ok) return;
      const data = await response.json();
      const allInvoices = Array.isArray(data) ? data : (data.invoices || data.results || []);
      
      // Filter invoices that contain line items with appointments linked to this referral
      const linkedInvoices = allInvoices.filter((inv) => {
        const lines = inv.invoice_lines || inv.line_items || [];
        if (!Array.isArray(lines) || lines.length === 0) return false;
        return lines.some((line) => {
          // Check if this appointment has payer_referral_letter matching our referralId
          const apptRef = line.appointment?.payer_referral_letter || line.appointment?.payer_referral_letter_id;
          return String(apptRef) === String(referralId) || String(line.appointment_id) === String(referralId);
        });
      });
      
      setReferralInvoices(linkedInvoices);
    } catch (error) {
      console.error('Failed to fetch invoices for referral:', error);
      setReferralInvoices([]);
    } finally {
      setLoadingInvoices(false);
    }
  };

  const handleAddReferralLetter = async () => {
    const current = getCurrentInsurance();
    if (!current.id || !current.newReferralId?.trim()) {
      alert('Enter a referral letter ID before adding.');
      return;
    }
    if (isReferralCreateBlocked) {
      alert('The referral document must pass the antivirus scan before it can be added.');
      return;
    }

    updateCurrentInsurance('creatingReferral', true);
    try {
      // Prepare FormData for file upload
      const formData = new FormData();
      formData.append('referral_id', current.newReferralId.trim());
      formData.append('title', current.newReferralTitle?.trim() || (current.provider ? `${current.provider} referral` : 'Referral Letter'));
      formData.append('status', 'received');
      formData.append('is_active', 'true');
      formData.append('valid_from', current.newReferralValidFrom || '');
      formData.append('valid_until', current.newReferralValidUntil || '');
      formData.append('policy_number', current.newReferralPolicyNumber || '');
      formData.append('member_id', current.newReferralMemberId || '');
      formData.append('group_number', current.newReferralGroupNumber || '');
      formData.append('approved_treatments', current.newReferralApprovedTreatments ? Number(current.newReferralApprovedTreatments) : '');
      formData.append('approved_amount', current.newReferralApprovedAmount ? Number(current.newReferralApprovedAmount) : '');
      if (current.newReferralDocumentUploadId) {
        formData.append('document_upload_id', current.newReferralDocumentUploadId);
      }

      const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Failed to add referral letter');
      }

      const created = await response.json();
      const isCreatedExpired = isReferralExpired(created);

      setInsuranceRecords((prev) => {
        const updated = [...prev];
        if (updated[currentTabIndex]) {
          const prevActiveIds = Array.isArray(updated[currentTabIndex].activeReferralLetterIds)
            ? updated[currentTabIndex].activeReferralLetterIds
            : [];
          updated[currentTabIndex] = {
            ...updated[currentTabIndex],
            referralLetters: [created, ...updated[currentTabIndex].referralLetters],
            activeReferralLetterId: String(created.id),
            activeReferralLetterIds: isCreatedExpired
              ? prevActiveIds
              : Array.from(new Set([String(created.id), ...prevActiveIds])),
            newReferralId: '',
            newReferralTitle: '',
            newReferralValidFrom: '',
            newReferralValidUntil: '',
            newReferralPolicyNumber: '',
            newReferralMemberId: '',
            newReferralGroupNumber: '',
            newReferralApprovedTreatments: '',
            newReferralApprovedAmount: '',
            newReferralPolicyEvidenceFile: null,
            newReferralPolicyEvidenceFileName: '',
            newReferralDocumentUploadId: '',
            newReferralDocumentUploadStatus: '',
          };
        }
        return updated;
      });

      setReferralSubTab(isCreatedExpired ? 1 : 0);
      setSelectedReferralId(created.id);
      setShowAddReferralForm(false);
      setShowInlinePolicyPanel(false);

      // Refetch referral letters to ensure document fields are populated
      try {
        const refetchResponse = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (refetchResponse.ok) {
          const updatedLetters = await refetchResponse.json();
          setInsuranceRecords((prev) => {
            const updated = [...prev];
            if (updated[currentTabIndex]) {
              updated[currentTabIndex] = {
                ...updated[currentTabIndex],
                referralLetters: Array.isArray(updatedLetters) ? updatedLetters : [],
              };
            }
            return updated;
          });
        }
      } catch (error) {
        console.error('Failed to refetch referral letters:', error);
      }

      // Refresh appointment usage after adding referral letter
      await refreshAppointmentUsage();
    } catch (error) {
      console.error('Failed to add referral letter:', error);
      alert('Failed to add referral letter.');
    } finally {
      updateCurrentInsurance('creatingReferral', false);
    }
  };

  const handleReferralDocumentUpdate = async (event, referralId) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf' && !file.type.startsWith('image/')) {
      alert('Please select a valid PDF or image file');
      event.target.value = '';
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('PDF file must be smaller than 5MB');
      event.target.value = '';
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file, file.name);

      const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/referral-letters/${referralId}/`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Failed to upload document: ${errorMessage}`);
      }

      console.log('Document uploaded successfully');

      // Refetch referral letters to update the display
      const current = getCurrentInsurance();
      const refetchResponse = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (refetchResponse.ok) {
        const updatedLetters = await refetchResponse.json();
        setInsuranceRecords((prev) => {
          const updated = [...prev];
          if (updated[currentTabIndex]) {
            updated[currentTabIndex] = {
              ...updated[currentTabIndex],
              referralLetters: Array.isArray(updatedLetters) ? updatedLetters : [],
            };
          }
          return updated;
        });
      }
      
      // Clear input for re-upload
      event.target.value = '';
    } catch (error) {
      console.error('Failed to upload document:', error);
      alert(`Failed to upload document: ${error.message}`);
      event.target.value = '';
    }
  };

  const queuePolicyEvidenceScan = async (insuranceId, file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/${insuranceId}/policy-evidence/`, {
      method: 'POST',
      headers: { 'Authorization': `Token ${token}` },
      body: formData,
    });
    if (!response.ok) {
      throw new Error((await response.text()) || 'Failed to upload policy document');
    }
    const result = await response.json();
    setInsuranceRecords((previous) => previous.map((insurance) => (
      String(insurance.id) === String(insuranceId)
        ? {
          ...insurance,
          policyEvidenceFile: null,
          policyEvidenceFileName: file.name,
          policyEvidenceUploadStatus: result.upload_status || 'pending',
        }
        : insurance
    )));
  };

  const queuePolicyEvidencePreScan = async (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/policy-evidence/pre-scan/`, {
      method: 'POST',
      headers: { 'Authorization': `Token ${token}` },
      body: formData,
    });
    if (!response.ok) {
      throw new Error((await response.text()) || 'Failed to upload policy document');
    }
    return response.json();
  };

  const handlePDFFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.type !== 'application/pdf' && !file.type.startsWith('image/')) {
      alert('Please select a valid PDF or image file');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('PDF file must be smaller than 5MB');
      return;
    }

    const current = getCurrentInsurance();
    if (current.id) {
      try {
        await queuePolicyEvidenceScan(current.id, file);
        setShowInlinePolicyPanel(true);
        setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: false }));
      } catch (error) {
        console.error('Failed to upload policy document:', error);
        alert('Failed to upload policy document.');
      } finally {
        event.target.value = '';
      }
      return;
    }

    try {
      const upload = await queuePolicyEvidencePreScan(file);
      updateCurrentInsurance('policyEvidenceFile', null);
      updateCurrentInsurance('policyEvidenceFileName', file.name);
      updateCurrentInsurance('policyEvidenceUploadId', upload.id);
      updateCurrentInsurance('policyEvidenceUploadStatus', upload.status || 'pending');
      setShowInlinePolicyPanel(true);
      setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: false }));
    } catch (error) {
      console.error('Failed to upload policy document:', error);
      alert('Failed to upload policy document.');
    } finally {
      event.target.value = '';
    }
  };

  const handleReferralDocumentUpload = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.type !== 'application/pdf' && !file.type.startsWith('image/')) {
        alert('Please select a valid PDF or image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('PDF file must be smaller than 5MB');
        return;
      }
      
      try {
        const formData = new FormData();
        formData.append('file', file, file.name);
        const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/referral-documents/pre-scan/`, {
          method: 'POST',
          headers: { 'Authorization': `Token ${token}` },
          body: formData,
        });
        if (!response.ok) {
          throw new Error((await response.text()) || 'Failed to upload referral document');
        }
        const upload = await response.json();
        updateCurrentInsurance('newReferralPolicyEvidenceFile', null);
        updateCurrentInsurance('newReferralPolicyEvidenceFileName', file.name);
        updateCurrentInsurance('newReferralDocumentUploadId', upload.id);
        updateCurrentInsurance('newReferralDocumentUploadStatus', upload.status || 'pending');
      } catch (error) {
        console.error('Failed to upload referral document:', error);
        alert('Failed to upload referral document.');
      } finally {
        event.target.value = '';
      }
    }
  };

  const handleSave = async (options = {}) => {
    if (!token || !patientId) {
      alert('Missing user context. Please log in again.');
      return;
    }

    const current = getCurrentInsurance();

    if (isPolicyScanInProgress) {
      alert('The insurance policy document is still being scanned. Wait for a clean result before saving again.');
      return;
    }
    if (current.policyEvidenceUploadId && policyScanStatus !== 'clean') {
      alert('The insurance policy document must pass the antivirus scan before saving.');
      return;
    }

    if (showInsuranceFields && (
      !String(current.provider || '').trim()
      || !String(current.planType || '').trim()
      || !String(current.policyNumber || '').trim()
    )) {
      alert('Please enter provider name, plan type, and policy number before saving.');
      return;
    }

    const activeLetterInput = String(current.activeReferralLetterId || '').trim();
    const matchedLetter = current.referralLetters.find((letter) => (
      String(letter.id) === activeLetterInput || String(letter.referral_id) === activeLetterInput
    ));
    const activeIds = Array.isArray(current.activeReferralLetterIds)
      ? current.activeReferralLetterIds.filter(Boolean).map(String)
      : [];
    const activeReferralLetterValue = activeIds.length > 0
      ? activeIds[0]
      : (activeLetterInput ? (matchedLetter ? String(matchedLetter.id) : activeLetterInput) : null);

    setIsSaving(true);
    try {
      const payload = {
        insurance_provider: String(current.provider || '').trim(),
        billing_email: String(current.billingEmail || '').trim() || null,
        plan_type: String(current.planType || '').trim() || null,
        policy_number: String(current.policyNumber || '').trim(),
        member_id: String(current.memberId || '').trim() || null,
        group_number: String(current.groupNumber || '').trim() || null,
        approved_treatments: current.approvedTreatments ? Number(current.approvedTreatments) : null,
        total_cost_amount: current.totalCostAmount ? Number(current.totalCostAmount) : null,
        coverage_valid_from: current.coverageValidFrom || null,
        coverage_valid_until: current.coverageValidUntil || null,
        referral_notes: String(current.referralNotes || '').trim() || null,
        active_referral_letter: activeReferralLetterValue,
        policy_upload_id: current.policyEvidenceUploadId || null,
        agreement: current.agreementId || null,
        review_notes: String(current.reviewNotes || '').trim() || null,
      };

      if (options.reconcileDuplicates) {
        payload.reconcile_duplicates = true;
      }

      // Note: care_provider is set by the backend during save(), not sent in the request

      const endpoint = current.id
        ? `${backendBaseUrl}/profile/patient/insurance/${current.id}/`
        : `${backendBaseUrl}/profile/patient/${patientId}/insurance/`;

      const response = await fetch(endpoint, {
        method: current.id ? 'PATCH' : 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMsg = 'Failed to save insurance details';
        try {
          // First try to get the response as text
          const text = await response.text();
          
          // Try to parse as JSON
          try {
            const errorData = JSON.parse(text);
            if (errorData.errors) {
              // Validation errors from serializer
              const errorList = Object.entries(errorData.errors)
                .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
                .join('\n');
              errorMsg = `Validation errors:\n${errorList}`;
            } else if (errorData.error) {
              errorMsg = errorData.error;
            } else if (errorData.detail) {
              errorMsg = errorData.detail;
            }
          } catch (parseError) {
            // If JSON parsing fails, use the raw text
            errorMsg = text || errorMsg;
          }
        } catch (e) {
          // Fallback to generic message
          console.error('Error processing response:', e);
        }
        throw new Error(errorMsg);
      }

      const saved = await response.json();
      const savedProviderDetailsBaseline = getProviderDetailsSnapshot({
        provider: saved.insurance_provider || '',
        billingEmail: saved.billing_email || '',
        planType: saved.plan_type || '',
        policyNumber: saved.policy_number || '',
        memberId: saved.member_id || '',
        groupNumber: saved.group_number || '',
        agreementId: current.agreementId || '',
      });
      
      // Update the current insurance record with saved data
      setInsuranceRecords((prev) => {
        const updated = [...prev];
        if (updated[currentTabIndex]) {
          updated[currentTabIndex] = {
            ...updated[currentTabIndex],
            id: saved.id,
            provider: saved.insurance_provider || '',
            billingEmail: saved.billing_email || '',
            planType: saved.plan_type || '',
            policyNumber: saved.policy_number || '',
            memberId: saved.member_id || '',
            groupNumber: saved.group_number || '',
            approvedTreatments: saved.approved_treatments == null ? '' : String(saved.approved_treatments),
            totalCostAmount: saved.total_cost_amount == null ? '' : String(saved.total_cost_amount),
            coverageValidFrom: saved.coverage_valid_from || '',
            coverageValidUntil: saved.coverage_valid_until || '',
            referralNotes: saved.referral_notes || '',
            activeReferralLetterIds: Array.isArray(current.activeReferralLetterIds)
              ? current.activeReferralLetterIds
              : (activeReferralLetterValue ? [String(activeReferralLetterValue)] : []),
            activeReferralLetterId: activeReferralLetterValue || '',
            isNew: false,
            isPendingReview: saved.is_pending_review || false,
            pendingReason: saved.pending_reason || '',
            reviewNotes: saved.review_notes || '',
            reviewedAt: saved.reviewed_at || '',
            reviewedByName: saved.reviewed_by_name || '',
            policyEvidenceFile: saved.policy_evidence_file || null,
            policyEvidenceFileName: saved.policy_evidence_file ? 'policy_document.pdf' : updated[currentTabIndex].policyEvidenceFileName,
            policyEvidenceUploadStatus: saved.policy_evidence_upload_status || updated[currentTabIndex].policyEvidenceUploadStatus || '',
            policyEvidenceUploadId: '',
            isPrimary: saved.is_primary || false,
            isActive: saved.is_active !== false,
            providerDetailsBaseline: savedProviderDetailsBaseline,
          };
        }
        return updated;
      });


      if (options.reconcileDuplicates && duplicateInsurances.length > 0) {
        const duplicateIds = new Set(duplicateInsurances.map((insurance) => String(insurance.id)));
        setInsuranceRecords((prev) => prev.map((insurance) => (
          duplicateIds.has(String(insurance.id))
            ? {
              ...insurance,
              isActive: false,
              isPrimary: false,
              isPendingReview: false,
            }
            : insurance
        )));
      }

      // Refresh appointment usage after save
      await refreshAppointmentUsage();

      // Save referral letter policy details for each referral
      const currentReferralLetters = Array.isArray(current.referralLetters) ? current.referralLetters : [];
      for (const letter of currentReferralLetters) {
        if (!letter?.id) continue;
        const letterPayload = {
          policy_number: letter.policy_number || null,
          member_id: letter.member_id || null,
          group_number: letter.group_number || null,
          approved_treatments: letter.approved_treatments ? Number(letter.approved_treatments) : null,
          approved_amount: letter.approved_amount ? Number(letter.approved_amount) : null,
          valid_from: letter.valid_from || null,
          valid_until: letter.valid_until || null,
        };

        try {
          const letterResponse = await fetch(
            `${backendBaseUrl}/profile/patient/insurance/referral-letters/${letter.id}/`,
            {
              method: 'PATCH',
              headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(letterPayload),
            }
          );

          if (!letterResponse.ok) {
            const message = await letterResponse.text();
            console.error(`Failed to save policy details for referral ${letter.id}:`, message);
          }
        } catch (error) {
          console.error(`Failed to save policy details for referral ${letter.id}:`, error);
        }
      }

      alert(options.reconcileDuplicates ? 'Insurance details reconciled successfully' : 'Insurance details saved successfully');
    } catch (error) {
      console.error('Failed to save insurance details:', error);
      const errorMsg = error.message || 'Failed to save insurance details. Please try again.';
      alert(errorMsg);
    } finally {
      setIsSaving(false);
    }
  };

  const handleApprovePendingInsuranceBilling = async () => {
    const current = getCurrentInsurance();

    if (!current.id) {
      alert('Save the insurance record first before approving billing.');
      return;
    }

    if (!insurancePolicyConfirmed || !referralLetterConfirmed) {
      alert('Please confirm both the insurance details and the referral letter details before approving billing.');
      return;
    }

    setIsSaving(true);
    try {
      const response = await fetch(`${backendBaseUrl}/api/profile/patient/insurance/${current.id}/review/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'approve',
          notes: String(current.reviewNotes || '').trim() || '',
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to approve billing');
      }

      const result = await response.json();
      const reviewedRecord = result.record || result;

      setInsuranceRecords((prev) => {
        const updated = [...prev];
        if (updated[currentTabIndex]) {
          updated[currentTabIndex] = {
            ...updated[currentTabIndex],
            isPendingReview: reviewedRecord.is_pending_review || false,
            reviewNotes: reviewedRecord.review_notes || '',
            reviewedAt: reviewedRecord.reviewed_at || '',
            reviewedByName: reviewedRecord.reviewed_by_name || '',
          };
        }
        return updated;
      });

      setInsurancePolicyConfirmed(false);
      setReferralLetterConfirmed(false);
      alert('Insurance billing approved successfully.');
    } catch (error) {
      console.error('Error approving pending insurance:', error);
      alert(error.message || 'Failed to approve billing.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeaderRoot}
          title={<span className={classes.cardHeaderTitle}>Insurance</span>}
        />
        <CardContent className={classes.cardContent}>
          {/*<Typography className={classes.bodyText}>
            Add your insurance details to enable automatic billing for treatments covered by your plan.
          </Typography>*/}
          

          {showInsuranceFields && insuranceRecords.length > 0 && (
            <>

              <Grid container spacing={2}>
                {/* Step 1: Insurance Provider */}
                <Grid item xs={12}>
                  <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 16, fontSize: 'clamp(0.88rem, 0.95vw, 1.125rem)' }}>
                    Insurance Provider Details
                  </Typography>
              <Box style={{ borderBottom: 1, borderColor: 'divider', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
                <Typography className={classes.bodyText}>
                  Add or edit insurance payer information, and add or edit insurance referral letters.
                </Typography>
                <Tabs
                  value={currentTabIndex}
                  onChange={(e, newIndex) => setCurrentTabIndex(newIndex)}
                  className={classes.tabsWrapper}
                  textColor="inherit"
                  variant="scrollable"
                  scrollButtons="auto"
                  classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
                >
                  {insuranceRecords.map((ins, index) => (
                    <Tab
                      key={index}
                      classes={{ root: classes.insuranceTab, selected: classes.selected }}
                      label={
                        <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                          <span>
                            {ins.provider && ins.provider.trim()
                              ? ins.provider 
                              : 'Insurance Provider Name'}
                          </span>
                          {insuranceRecords.length > 1 && (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteInsurance(index);
                              }}
                              style={{ marginLeft: 4, padding: 2 }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      }
                    />
                  ))}
                  <Tab
                    classes={{ root: clsx(classes.insuranceTab, classes.addInlineTab), selected: classes.selected }}
                    label="ADD NEW"
                    icon={<AddIcon style={{ fontSize: 'clamp(0.98rem, 0.95vw, 1.125rem)', marginRight: 'clamp(3px, 0.26vw, 4px)', display: 'flex', alignSelf: 'center', marginTop: 3 }} />}
                    iconPosition="start"
                    title="Add New Insurance"
                    onClick={(e) => {
                      e.preventDefault();
                      addNewInsurance();
                    }}
                  />
                </Tabs>
              </Box>
                </Grid>

                {/* Link to Clinic Agreement */}
                {clinicAgreements.length > 0 && (
                  <Grid item xs={12} sm={3}>
                    <TextField
                      select
                      fullWidth
                      label="Clinic Insurer Agreement"
                      value={currentIns.agreementId || ''}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        updateCurrentInsurance('agreementId', selectedId);
                        if (selectedId) {
                          const agreement = clinicAgreements.find((a) => String(a.id) === String(selectedId));
                          if (agreement) {
                            updateCurrentInsurance('provider', agreement.insurance_provider_name);
                            // Auto-fill billing email from the first active payer detail
                            const activePayer = (agreement.payer_details || []).find((pd) => pd.payer_status === 'active');
                            if (activePayer && activePayer.billing_email) {
                              updateCurrentInsurance('billingEmail', activePayer.billing_email);
                            }
                          }
                        }
                      }}
                      variant="outlined"
                      size="small"
                      className={clsx(classes.orangeFocused, classes.input, classes.selectSmall)}
                    >
                      <MenuItem value="">
                        <em>None (manual entry)</em>
                      </MenuItem>
                      {clinicAgreements.filter((a) => a.is_active).map((agreement) => (
                        <MenuItem key={agreement.id} value={agreement.id}>
                          {agreement.insurance_provider_name}
                          {agreement.business_registration_number ? ` (CVR: ${agreement.business_registration_number})` : ''}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Insurance"
                    value={currentIns.provider}
                    onChange={(e) => updateCurrentInsurance('provider', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Billing Email"
                    type="email"
                    value={currentIns.billingEmail || ''}
                    onChange={(e) => updateCurrentInsurance('billingEmail', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Plan Type"
                    value={currentIns.planType}
                    onChange={(e) => updateCurrentInsurance('planType', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Policy Number"
                    value={currentIns.policyNumber}
                    onChange={(e) => updateCurrentInsurance('policyNumber', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                {showProviderDetailsSaveButton && (
                  <Grid item xs={12}>
                    <Card className={classes.card} style={{ marginTop: 16, borderRadius: 8 }}>
                      <CardContent className={classes.cardContent}>
                        <Button
                          className={classes.Button}
                          variant="contained"
                          onClick={handleSave}
                          disabled={isSaving || !showInsuranceFields || isPolicySaveBlocked}
                          fullWidth
                        >
                          {isSaving ? 'Saving...' : 'Save Provider Details'}
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                {currentIns.isPendingReview && (
                  <Grid item xs={12}>
                    <Box style={{ paddingTop: 2 }}>
                      <FormControlLabel
                        control={(
                          <Checkbox
                                style={{ color: '#FF7F27' }}
                            checked={insurancePolicyConfirmed}
                            onChange={(e) => setInsurancePolicyConfirmed(e.target.checked)}
                          />
                        )}
                        label="Insurance provider and policy number are correct"
                        style={{ alignItems: 'center', color: '#002D55', marginLeft: -8 }}
                      />
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12}>
                  {((!showUploadSection[currentTabIndex] && currentIns.policyEvidenceFileName) || (currentIns.referralLetters && currentIns.referralLetters.some(l => l.file_url))) ? (
                    <Box style={{ border: '1px solid #E0E0E0', borderRadius: 8, padding: 'clamp(8px, 0.78vw, 12px)', marginTop: 'clamp(6px, 0.52vw, 8px)', backgroundColor: '#F5F5F5' }}>
                      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap' }}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap', flex: 1 }}>
                          <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', whiteSpace: 'nowrap' }}>📄 Insurance Policy Document:</Typography>
                          {currentIns.policyEvidenceFileName && (
                            <Chip
                              label={hasPolicyAwaitingSave
                                ? `${currentIns.policyEvidenceFileName} - scan cleared; ready to save`
                                : (isPolicyScanInProgress
                                ? `${currentIns.policyEvidenceFileName} - scanning`
                                : (isPolicyScanRejected
                                  ? `${currentIns.policyEvidenceFileName} - scan failed`
                                  : currentIns.policyEvidenceFileName))}
                              onClick={currentIns.policyEvidenceFile ? () => {
                                setViewingDocument(currentIns.policyEvidenceFile);
                                setViewingDocumentName(currentIns.policyEvidenceFileName);
                                setShowDocumentViewer(true);
                              } : undefined}
                              style={{
                                backgroundColor: isPolicyScanRejected ? '#FFEBEE' : (isPolicyScanInProgress ? '#FFF8E1' : '#E8F5E9'),
                                color: isPolicyScanRejected ? '#C62828' : (isPolicyScanInProgress ? '#F57F17' : '#2E7D32'),
                                cursor: currentIns.policyEvidenceFile ? 'pointer' : 'default',
                              }}
                              icon={<DescriptionIcon />}
                            />
                          )}
                        </Box>
                        {currentIns.policyEvidenceFileName && (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: true }))}
                            style={{ color: '#002D55', borderColor: '#002D55' }}
                          >
                            Replace
                          </Button>
                        )}
                      </Box>

                      {/* Referral Letter Documents Section */}
                      {currentIns.referralLetters && currentIns.referralLetters.some(l => l.file_url) && (
                        <Box style={{ marginTop: 'clamp(8px, 0.78vw, 12px)' }}>
                          <Divider style={{ margin: 'clamp(6px, 0.52vw, 8px) 0' }} />
                          <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 'clamp(6px, 0.52vw, 8px)' }}>
                          <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', marginBottom: 'clamp(6px, 0.52vw, 8px)', marginTop: 'clamp(6px, 0.52vw, 8px)' }}>📄 Referral Letter for treatment:</Typography>
                            {currentIns.referralLetters.map((referral) => (
                              referral.file_url && (
                                <Chip
                                  key={referral.id}
                                  label={getShortDocumentLabel(referral)}
                                  onClick={() => {
                                    setViewingDocument(referral.file_url);
                                    setViewingDocumentName(getShortDocumentLabel(referral));
                                    setShowDocumentViewer(true);
                                  }}
                                  style={{ backgroundColor: '#E8F5E9', color: '#2E7D32', cursor: 'pointer' }}
                                  icon={<DescriptionIcon />}
                                />
                              )
                            ))}
                          </Box>
                        </Box>
                      )}

                      <Typography style={{ color: '#999', fontSize: 'clamp(9px, 0.72vw, 11px)', marginTop: 'clamp(8px, 0.78vw, 12px)', fontStyle: 'italic' }}>
                        ✓ Documents uploaded for this insurance will be displayed here. Click on the document name to view or replace it.
                      </Typography>
                    </Box>
                  ) : (
                    <Collapse in={showUploadSection[currentTabIndex] !== false}>
                      <Box style={{ border: '2px dashed #FF7F27', borderRadius: 8, padding: 'clamp(12px, 1.04vw, 16px)', backgroundColor: '#fff9f5', marginTop: 'clamp(6px, 0.52vw, 8px)' }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 'clamp(6px, 0.52vw, 8px)', fontSize: 'clamp(12px, 0.9vw, 15px)' }}>
                          📄 Upload Insurance Policy or Referral Letter (PDF) - Required
                        </Typography>
                        <Typography style={{ color: '#666', fontSize: 'clamp(11px, 0.85vw, 14px)', marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                          To verify your insurance coverage, please upload a PDF or photo of your insurance policy card, referral letter, or coverage document (Max 5MB).
                        </Typography>
                        <input
                          type="file"
                          accept=".pdf,image/*"
                          capture="environment"
                          onChange={handlePDFFileChange}
                          style={{ display: 'block', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}
                        />
                        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 'clamp(6px, 0.52vw, 8px)', marginTop: 'clamp(8px, 0.78vw, 12px)' }}>
                          <Button
                            className={classes.Button}
                            variant="contained"
                            size="small"
                            onClick={() => openDocumentQr('policy')}
                          >
                            QR upload link
                          </Button>
                          <Typography style={{ color: '#FF7F27', fontSize: 'clamp(9px, 0.72vw, 11px)', fontStyle: 'italic', alignSelf: 'center' }}>
                            Scan to open this insurance upload context on a phone.
                          </Typography>
                        </Box>
                        <Typography style={{ color: '#FF7F27', fontSize: 'clamp(9px, 0.72vw, 11px)', marginTop: 'clamp(6px, 0.52vw, 8px)', fontStyle: 'italic' }}>
                          Your submission will be reviewed by our admin team for verification.
                        </Typography>
                      </Box>
                    </Collapse>
                  )}
                </Grid>

                {currentIns.isPendingReview && (
                  <Grid item xs={12}>
                    <Box style={{ backgroundColor: '#FFF3E0', border: '1px solid #FFB74D', borderRadius: 8, padding: 'clamp(8px, 0.78vw, 12px)' }}>
                      <Typography style={{ fontWeight: 600, color: '#E65100', fontSize: 'clamp(12px, 0.85vw, 14px)', marginBottom: 'clamp(3px, 0.26vw, 4px)' }}>
                        ⏳ Pending Admin Review
                      </Typography>
                      <Typography style={{ color: '#BF360C', fontSize: 'clamp(11px, 0.85vw, 14px)' }}>
                        This insurance record exceeds the default limit of 2 per patient and is awaiting admin approval. You will be notified once it's been reviewed.
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {/* Document Viewer Dialog */}
                <Dialog
                  open={showDocumentViewer}
                  onClose={() => setShowDocumentViewer(false)}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{ style: { borderRadius: 12 } }}
                >
                  <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#002D55', fontWeight: 600 }}>
                    {viewingDocumentName}
                    <IconButton onClick={() => setShowDocumentViewer(false)} size="small">
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers>
                    {viewingDocument && (
                      <Box component="embed" src={viewingDocument.startsWith('http') ? viewingDocument : viewingDocument} type="application/pdf" style={{ width: '100%', height: 'clamp(450px, 39vw, 600px)', border: 'none' }} />
                    )}
                  </DialogContent>
                </Dialog>

                {/* Step 2: Referral Letters 
                <Grid item xs={12}>
                  <Divider style={{ margin: '16px 0' }} />
                  <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 0 }}>
                    Referral Letters
                  </Typography>
                </Grid>*/}

                <Grid item xs={12}>
                  <Collapse in={showAddReferralForm}>
                    <Box style={{ border: '1px solid #E0E0E0', borderRadius: 12, padding: 'clamp(12px, 1.04vw, 16px)', marginTop: 'clamp(6px, 0.52vw, 8px)', background: '#FAFAFA' }}>
                      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.9vw, 16px)', textTransform: 'uppercase' }}>
                          Add New Referral Letter
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => setShowAddReferralForm(false)}
                          className={classes.closeIconButton}
                          style={{ borderRadius: '50%', padding: 'clamp(4px, 0.39vw, 8px)' }}
                        >
                          <CloseIcon style={{ fontSize: 'clamp(0.92rem, calc(2px + 0.722vw), 1.2rem)' }} />
                        </IconButton>
                      </Box>

                      <Box style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                        {currentIns.newReferralPolicyEvidenceFileName ? (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap' }}>
                            <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', whiteSpace: 'nowrap' }}>📄 Referral Document:</Typography>
                            <Chip
                              label={isNewReferralDocumentScanInProgress
                                ? `${currentIns.newReferralPolicyEvidenceFileName} - scanning`
                                : (isNewReferralDocumentScanRejected
                                  ? `${currentIns.newReferralPolicyEvidenceFileName} - scan failed`
                                  : (currentIns.newReferralDocumentUploadId
                                    ? `${currentIns.newReferralPolicyEvidenceFileName} - scan cleared; ready to add`
                                    : currentIns.newReferralPolicyEvidenceFileName))}
                              onDelete={() => {
                                updateCurrentInsurance('newReferralPolicyEvidenceFile', null);
                                updateCurrentInsurance('newReferralPolicyEvidenceFileName', '');
                                updateCurrentInsurance('newReferralDocumentUploadId', '');
                                updateCurrentInsurance('newReferralDocumentUploadStatus', '');
                              }}
                              style={{
                                backgroundColor: isNewReferralDocumentScanRejected ? '#FFEBEE' : (isNewReferralDocumentScanInProgress ? '#FFF8E1' : '#E8F5E9'),
                                color: isNewReferralDocumentScanRejected ? '#C62828' : (isNewReferralDocumentScanInProgress ? '#F57F17' : '#2E7D32'),
                                cursor: 'pointer',
                              }}
                              icon={<DescriptionIcon />}
                            />
                          </Box>
                        ) : (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 'clamp(6px, 0.52vw, 8px)' }}>
                            <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', whiteSpace: 'nowrap' }}>📄 Referral Document:</Typography>
                            <input
                              type="file"
                              accept=".pdf,image/*"
                              capture="environment"
                              onChange={handleReferralDocumentUpload}
                              style={{ display: 'block' }}
                            />
                            <Typography style={{ color: '#999', fontSize: 'clamp(9px, 0.72vw, 11px)', fontStyle: 'italic' }}>Optional - upload specific to this referral</Typography>
                          </Box>
                        )}
                      </Box>

                      {currentIns.newReferralPolicyEvidenceFile && (
                        <Box style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => setShowInlinePolicyPanel((prev) => !prev)}
                          >
                            {showInlinePolicyPanel ? 'Hide PDF Panel' : 'Show PDF Panel'}
                          </Button>
                        </Box>
                      )}
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={currentIns.newReferralPolicyEvidenceFile && showInlinePolicyPanel ? 7 : 12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="New Referral Letter ID"
                                value={currentIns.newReferralId}
                                onChange={(e) => updateCurrentInsurance('newReferralId', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Title (e.g. Knee, Elbow)"
                                value={currentIns.newReferralTitle || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralTitle', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Valid From"
                                type="date"
                                value={currentIns.newReferralValidFrom || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralValidFrom', e.target.value)}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Valid Until"
                                type="date"
                                value={currentIns.newReferralValidUntil || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralValidUntil', e.target.value)}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Divider style={{ margin: 'clamp(6px, 0.52vw, 8px) 0' }} />
                              <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 'clamp(6px, 0.52vw, 8px)', marginTop: 'clamp(6px, 0.52vw, 8px)', fontSize: 'clamp(11px, 0.85vw, 14px)' }}>
                                Policy Information (Optional)
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Policy Number"
                                value={currentIns.newReferralPolicyNumber || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralPolicyNumber', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Member ID"
                                value={currentIns.newReferralMemberId || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralMemberId', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Group Number"
                                value={currentIns.newReferralGroupNumber || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralGroupNumber', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Approved Treatments"
                                type="number"
                                value={currentIns.newReferralApprovedTreatments || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralApprovedTreatments', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Approved Amount ($)"
                                type="number"
                                value={currentIns.newReferralApprovedAmount || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralApprovedAmount', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container spacing={1} style={{ marginTop: 'clamp(6px, 0.52vw, 8px)' }}>
                                <Grid item xs={6}>
                                  <Button
                                    className={classes.Button}
                                    variant="contained"
                                    onClick={handleAddReferralLetter}
                                    disabled={currentIns.creatingReferral || !currentIns.id || isReferralCreateBlocked}
                                    fullWidth
                                  >
                                    {currentIns.creatingReferral ? 'Adding...' : 'Confirm'}
                                  </Button>
                                </Grid>
                                <Grid item xs={6}>
                                  <Button
                                    onClick={() => setShowAddReferralForm(false)}
                                    className={classes.closeIconButton}
                                    fullWidth
                                  >
                                    Cancel
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {currentIns.newReferralPolicyEvidenceFile && showInlinePolicyPanel && (
                          <Grid item xs={12} md={5}>
                            <Box style={{ border: '1px solid #E0E0E0', borderRadius: 8, backgroundColor: '#FFFFFF', padding: 'clamp(6px, 0.52vw, 8px)' }}>
                              <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 'clamp(3px, 0.26vw, 4px)', fontSize: 'clamp(12px, 0.85vw, 14px)' }}>
                                Referral Document
                              </Typography>
                              <Typography style={{ color: '#666666', marginBottom: 'clamp(6px, 0.52vw, 8px)', fontSize: 'clamp(9px, 0.72vw, 11px)' }}>
                                Keep this open while filling the referral details.
                              </Typography>
                              <Box
                                component="embed"
                                src={String(currentIns.newReferralPolicyEvidenceFile).startsWith('data:') ? currentIns.newReferralPolicyEvidenceFile : `data:application/pdf;base64,${currentIns.newReferralPolicyEvidenceFile}`}
                                type="application/pdf"
                                style={{ width: '100%', height: 'clamp(390px, 33.8vw, 520px)', border: '1px solid #DDD', borderRadius: 6 }}
                              />
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  </Collapse>
                </Grid>

                <Grid item xs={12}>
                  <Box style={{ borderBottom: 1, borderColor: 'divider', marginTop: 'clamp(6px, 0.52vw, 8px)', display: 'flex', alignItems: 'center' }}>
                    <Tabs
                      value={referralSubTab}
                      onChange={(e, newValue) => {
                        setReferralSubTab(newValue);
                        const letters = newValue === 0 ? currentReferralLetters : previousReferralLetters;
                        if (letters.length === 0) {
                          setSelectedReferralId(null);
                        } else if (!selectedReferralId || !letters.find(l => l.id === selectedReferralId)) {
                          setSelectedReferralId(letters[0].id);
                        }
                      }}
                      className={classes.tabsWrapper}
                      textColor="inherit"
                      indicatorColor="primary"
                      classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
                    >
                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Current Referral Letters (${currentReferralLetters.length})`} />
                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Previous Referral Letters (${previousReferralLetters.length})`} />
                    <Tab
                      classes={{ root: clsx(classes.insuranceTab, classes.addInlineTab), selected: classes.selected }}
                      label="ADD NEW"
                      icon={<AddIcon style={{ fontSize: 'clamp(0.98rem, 0.95vw, 1.125rem)', marginRight: 'clamp(3px, 0.26vw, 4px)', display: 'flex', alignSelf: 'center', marginTop: 3 }} />}
                      iconPosition="start"
                      title="Add New Referral Letter"
                      onClick={() => setShowAddReferralForm(!showAddReferralForm)}
                    />
                    </Tabs>
                    {/*<Button 
                      size="small" 
                      onClick={() => setShowAddReferralForm(!showAddReferralForm)}
                      //style={{ color: showAddReferralForm ? '#FF7F27' : '#002D55', marginRight: 8 }}
                      className={classes.Button}
                    >
                      + Add new
                    </Button>*/}
                  </Box>
                  <Box style={{ display: 'flex', gap: 'clamp(8px, 0.78vw, 12px)', alignItems: 'flex-start', marginTop: 'clamp(12px, 1.04vw, 16px)' }}>
                    <Select
                      className={classes.referralDropdown}
                      value={selectedReferralId || ''}
                      onChange={(e) => setSelectedReferralId(e.target.value)}
                      onClose={(e) => {
                        if (e.target) {
                          e.target.blur();
                        }
                        setTimeout(() => {
                          if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                          }
                        }, 0);
                      }}
                      variant="outlined"
                      style={{ flex: 1, minHeight: 'clamp(36px, 3.13vw, 48px)' }}
                    >
                      {(referralSubTab === 0 ? currentReferralLetters : previousReferralLetters).length === 0 ? (
                        <MenuItem disabled value="">
                          {referralSubTab === 0 ? 'No active non-expired referral letters.' : 'No previous expired referral letters.'}
                        </MenuItem>
                      ) : (
                        (referralSubTab === 0 ? currentReferralLetters : previousReferralLetters).map((letter) => (
                          <MenuItem key={letter.id} value={letter.id}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 0.78vw, 12px)' }}>
                              <ArchiveIcon style={{ color: '#FF7F27' }} />
                              <Box>
                                <div style={{ color: '#002D55', fontWeight: 600 }}>
                                  {letter.referral_id} - <span style={{ color: '#FF7F27' }}>{letter.title || 'Referral Letter'}</span>
                                </div>
                                <div style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666', marginTop: 2 }}>
                                  Status: {isReferralExpired(letter) ? 'expired' : (letter.status || 'received')} | Valid: {letter.valid_from || '-'} to {letter.valid_until || '-'}
                                </div>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))
                      )}
                    </Select>
                    {selectedReferral && (
                      <Button
                        className={classes.removeButton}
                        onClick={() => handleRemoveReferralLetter(selectedReferralId)}
                        style={{ marginTop: 'clamp(4px, 0.39vw, 6px)' }}
                      >
                        Remove
                      </Button>
                    )}
                  </Box>
                </Grid>

                {/* Step 3: Referral & Policy Details (Merged) */}
                {selectedReferral && (
                  <>
                    <Grid item xs={12}>
                      <Divider style={{ margin: 'clamp(12px, 1.04vw, 16px) 0' }} />
                      <Box className={classes.referralDetailsCard}>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'clamp(12px, 1.04vw, 16px)', flexWrap: 'wrap', gap: 'clamp(8px, 0.78vw, 12px)' }}>
                          <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.9vw, 16px)' }}>
                            Referral & Policy Details for: <span style={{ color: '#FF7F27' }}>{selectedReferral.title || selectedReferral.referral_id}</span>
                          </Typography>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap' }}>
                            {isReferralScanInProgress && (
                              <Tooltip title="Document is being scanned before it can be used.">
                                <Chip
                                  size="small"
                                  icon={<CircularProgress size={14} />}
                                  label="Scanning document"
                                  style={{ backgroundColor: '#E3F2FD', color: '#1565C0' }}
                                />
                              </Tooltip>
                            )}
                            {referralScanStatus === 'clean' && (
                              <Tooltip title="Document passed the security scan.">
                                <Chip
                                  size="small"
                                  icon={<CheckCircleIcon />}
                                  label="Document checked"
                                  style={{ backgroundColor: '#E8F5E9', color: '#2E7D32' }}
                                />
                              </Tooltip>
                            )}
                            {isReferralScanRejected && (
                              <Tooltip title="Document could not be accepted. Replace it to try again.">
                                <Chip
                                  size="small"
                                  icon={<ErrorOutlineIcon />}
                                  label={referralScanStatus === 'rejected' ? 'Document rejected' : 'Scan unavailable'}
                                  style={{ backgroundColor: '#FFEBEE', color: '#C62828' }}
                                />
                              </Tooltip>
                            )}
                            {selectedReferral?.file_url && (
                              <Chip
                                label={getShortDocumentLabel(selectedReferral)}
                                onClick={() => {
                                  setViewingDocument(selectedReferral.file_url);
                                  setViewingDocumentName(getShortDocumentLabel(selectedReferral));
                                  setShowDocumentViewer(true);
                                }}
                                style={{ backgroundColor: '#E8F5E9', color: '#2E7D32', cursor: 'pointer' }}
                                icon={<DescriptionIcon />}
                              />
                            )}
                            <Button
                              component="label"
                              size="small"
                              variant="outlined"
                              disabled={isReferralScanInProgress}
                              style={{ color: '#002D55', borderColor: '#002D55' }}
                            >
                              {selectedReferral?.file_url ? 'Replace' : 'Upload'}
                              <input
                                type="file"
                                accept=".pdf,image/*"
                                capture="environment"
                                onChange={(e) => handleReferralDocumentUpdate(e, selectedReferral.id)}
                                hidden
                              />
                            </Button>
                            <Button
                              className={classes.Button}
                              variant="contained"
                              size="small"
                              onClick={() => openDocumentQr('referral', selectedReferral)}
                            >
                              QR upload link
                            </Button>
                          </Box>
                        </Box>

                        {currentIns.isPendingReview && (
                          <Box style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)' }}>
                            <FormControlLabel
                              control={(
                                <Checkbox
                                  style={{ color: '#FF7F27' }}
                                  checked={referralLetterConfirmed}
                                  onChange={(e) => setReferralLetterConfirmed(e.target.checked)}
                                />
                              )}
                              label="Referral Letter ID and approved treatments are correct"
                              style={{ alignItems: 'center', color: '#002D55', marginLeft: -8 }}
                            />
                          </Box>
                        )}
                        
                        {/* Usage Counters - Clickable to expand details */}
                        <Box 
                          onClick={() => setUsageDrawerOpen(!usageDrawerOpen)}
                          style={{ 
                            display: 'flex', 
                            gap: 'clamp(12px, 1.04vw, 16px)', 
                            marginBottom: usageDrawerOpen ? 0 : 'clamp(16px, 1.3vw, 20px)', 
                            padding: 'clamp(12px, 1.04vw, 16px)', 
                            backgroundColor: '#E3F2FD', 
                            borderRadius: usageDrawerOpen ? '8px 8px 0 0' : 8,
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#BBDEFB'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#E3F2FD'}
                        >
                          <Box style={{ flex: 1, textAlign: 'center' }}>
                            <Typography style={{ fontSize: 'clamp(11px, 0.9vw, 14px)', color: '#666666', fontWeight: 600, marginBottom: 'clamp(3px, 0.26vw, 4px)' }}>Treatments Used</Typography>
                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', color: '#002D55', fontWeight: 'bold' }}>
                              {selectedReferral?.treatments_used ?? '0'} / {selectedReferral?.approved_treatments || '0'}
                            </Typography>
                          </Box>
                          <Box style={{ flex: 1, textAlign: 'center' }}>
                            <Typography style={{ fontSize: 'clamp(11px, 0.9vw, 14px)', color: '#666666', fontWeight: 600, marginBottom: 'clamp(3px, 0.26vw, 4px)' }}>Amount Used</Typography>
                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', color: '#002D55', fontWeight: 'bold' }}>
                              ${selectedReferral?.amount_used ?? '0'} / ${selectedReferral?.approved_amount || '0'}
                            </Typography>
                          </Box>
                          <Box style={{ display: 'flex', alignItems: 'center', color: '#FF7F27' }}>
                            <ExpandMoreIcon style={{ transform: usageDrawerOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                          </Box>
                        </Box>

                        {/* Collapsible Appointment Details */}
                        <Collapse in={usageDrawerOpen} timeout="auto" unmountOnExit>
                          <Box style={{ 
                            padding: 'clamp(16px, 1.3vw, 20px)', 
                            backgroundColor: '#f7faff', 
                            borderRadius: '0 0 8px 8px',
                            marginBottom: 'clamp(16px, 1.3vw, 20px)',
                            border: '1px solid #BBDEFB',
                            borderTop: 'none'
                          }}>
                            {(() => {
                              // Calculate referral appointments for use in Tab label and content
                              const referralAppointments = allAppointments.filter((apt) => {
                                if (!isUsageEligibleStatus(apt?.status)) return false;
                                if (!isInsurancePayer(apt)) return false;
                                const appointmentReferralId = extractAppointmentReferralId(apt);
                                return String(appointmentReferralId) === String(selectedReferral.id);
                              });

                              return (
                                <>
                                  {/* Tabs for Appointments and Invoices */}
                                  <Box style={{ borderBottom: '1px solid #ddd', marginBottom: 'clamp(12px, 1.04vw, 16px)' }}>
                                    <Tabs
                                      value={invoicesDrawerTab}
                                      onChange={(e, newValue) => setInvoicesDrawerTab(newValue)}
                                      variant="standard"
                                    >
                                      <Tab label={`Appointments (${Math.max(0, referralAppointments?.length || 0)})`} />
                                      <Tab label={`Invoices (${Math.max(0, referralInvoices.length)})`} />
                                    </Tabs>
                                  </Box>

                                  {/* APPOINTMENTS TAB */}
                                  {invoicesDrawerTab === 0 && (
                                    <>
                                      {referralAppointments.length === 0 ? (
                                        <Box style={{ padding: 'clamp(30px, 2.6vw, 40px)', textAlign: 'center' }}>
                                          <Typography style={{ color: '#999999', fontStyle: 'italic' }}>
                                            No appointments billed to this referral letter yet
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <>
                                          {referralAppointments.map((apt) => {
                                    const aptDate = new Date(apt.start_datetime);
                                    const status = String(apt.status || '').toLowerCase();
                                    const price = apt.booked_price ? Number(apt.booked_price) : 0;

                                    return (
                                      <Card key={apt.id} style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)', border: '1px solid #e0e0e0', borderRadius: 8 }}>
                                        <CardContent style={{ padding: 'clamp(12px, 1.04vw, 16px)' }}>
                                          <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
                                            <Box>
                                              <Typography style={{ fontSize: 'clamp(12px, 0.9vw, 16px)', fontWeight: 600, color: '#002D55' }}>
                                                {aptDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
                                              </Typography>
                                              <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666', marginTop: 'clamp(3px, 0.26vw, 4px)' }}>
                                                {aptDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                                                {apt.service_name && ` • ${apt.service_name}`}
                                              </Typography>
                                            </Box>
                                            <Box style={{ textAlign: 'right' }}>
                                              <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', fontWeight: 'bold', color: '#002D55' }}>
                                                ${price.toFixed(2)}
                                              </Typography>
                                            </Box>
                                          </Box>

                                          <Box style={{ display: 'flex', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap', marginTop: 'clamp(8px, 0.78vw, 12px)' }}>
                                            <Chip
                                              label={status}
                                              size="small"
                                              style={{
                                                backgroundColor: status === 'completed' ? '#d4edda' : 
                                                                status === 'confirmed' ? '#cce5ff' :
                                                                status === 'cancelled' ? '#f8d7da' : '#e0e0e0',
                                                color: status === 'completed' ? '#155724' :
                                                       status === 'confirmed' ? '#004085' :
                                                       status === 'cancelled' ? '#721c24' : '#666666',
                                                textTransform: 'capitalize',
                                              }}
                                            />
                                            <Chip
                                              label="Insurance"
                                              size="small"
                                              style={{
                                                backgroundColor: '#fff3cd',
                                                color: '#856404',
                                              }}
                                            />
                                            {apt.appointment_type && (
                                              <Chip
                                                label={apt.appointment_type}
                                                size="small"
                                                style={{
                                                  backgroundColor: '#f5f5f5',
                                                  color: '#666666',
                                                }}
                                              />
                                            )}
                                          </Box>

                                          {(apt.therapist_name || apt.location) && (
                                            <Box style={{ marginTop: 'clamp(8px, 0.78vw, 12px)', paddingTop: 'clamp(8px, 0.78vw, 12px)', borderTop: '1px solid #f0f0f0' }}>
                                              {apt.therapist_name && (
                                                <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666' }}>
                                                  <strong>Therapist:</strong> {apt.therapist_name}
                                                </Typography>
                                              )}
                                              {apt.location && (
                                                <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666', marginTop: 'clamp(3px, 0.26vw, 4px)' }}>
                                                  <strong>Location:</strong> {apt.location}
                                                </Typography>
                                              )}
                                            </Box>
                                          )}
                                        </CardContent>
                                      </Card>
                                    );
                                  })}
                                        </>
                                      )}
                                    </>
                                  )}

                                  {/* INVOICES TAB */}
                                  {invoicesDrawerTab === 1 && (
                              <>
                                {loadingInvoices && (
                                  <Box style={{ padding: 'clamp(30px, 2.6vw, 40px)', textAlign: 'center' }}>
                                    <Typography style={{ color: '#666666' }}>Loading invoices...</Typography>
                                  </Box>
                                )}
                                {!loadingInvoices && referralInvoices.length === 0 && (
                                  <Box style={{ padding: 'clamp(30px, 2.6vw, 40px)', textAlign: 'center' }}>
                                    <Typography style={{ color: '#999999', fontStyle: 'italic' }}>
                                      No invoices found for this referral letter
                                    </Typography>
                                  </Box>
                                )}
                                {!loadingInvoices && referralInvoices.length > 0 && referralInvoices.map((invoice) => {
                                  const invDate = new Date(invoice.invoice_date);
                                  const totalAmount = invoice.total_amount ? Number(invoice.total_amount) : 0;
                                  const patientPortion = invoice.patient_portion_amount ? Number(invoice.patient_portion_amount) : null;
                                  const insurancePortion = invoice.insurance_portion_amount ? Number(invoice.insurance_portion_amount) : null;
                                  const status = String(invoice.status || '').toLowerCase();
                                  const appointmentCount = invoice.appointment_count || invoice.invoice_lines?.length || 0;
                                  const services = [...new Set((invoice.invoice_lines || []).map((l) => l.service_name).filter(Boolean))];
                                  const eanOk = invoice.ean_submission_status && ['delivered', 'accepted'].includes(invoice.ean_submission_status);

                                  return (
                                    <Card key={invoice.id} style={{ marginBottom: 'clamp(8px, 0.78vw, 12px)', border: '1px solid #e0e0e0', borderRadius: 8 }}>
                                      <CardContent style={{ padding: 'clamp(12px, 1.04vw, 16px)' }}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'clamp(6px, 0.52vw, 8px)' }}>
                                          <Box>
                                            <Box style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                              <Typography style={{ fontSize: 'clamp(12px, 0.9vw, 16px)', fontWeight: 600, color: '#002D55' }}>
                                                Invoice #{invoice.invoice_number || invoice.id}
                                              </Typography>
                                              {eanOk && (
                                                <Tooltip title="Sent via EAN successfully">
                                                  <CheckCircleIcon style={{ fontSize: 14, color: '#2E7D32' }} />
                                                </Tooltip>
                                              )}
                                              {invoice.sent_date && (
                                                <Tooltip title={invoice.email_opened ? 'Invoice viewed by patient' : 'Invoice sent — not yet viewed (may be in spam)'}>
                                                  <MarkunreadMailboxIcon style={{ fontSize: 14, color: invoice.email_opened ? '#1565C0' : '#9E9E9E' }} />
                                                </Tooltip>
                                              )}
                                            </Box>
                                            <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666', marginTop: 'clamp(3px, 0.26vw, 4px)' }}>
                                              {invDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                              {appointmentCount > 0 && ` • ${appointmentCount} appointment${appointmentCount !== 1 ? 's' : ''}`}
                                            </Typography>
                                            {services.length > 0 && (
                                              <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#888', marginTop: 2 }}>
                                                {services.join(', ')}
                                              </Typography>
                                            )}
                                          </Box>
                                          <Box style={{ textAlign: 'right' }}>
                                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', fontWeight: 'bold', color: '#002D55' }}>
                                              ${totalAmount.toFixed(2)}
                                            </Typography>
                                            {insurancePortion !== null && (
                                              <Typography style={{ fontSize: 11, color: '#1565C0' }}>
                                                Insurance: ${insurancePortion.toFixed(2)}
                                              </Typography>
                                            )}
                                            {patientPortion !== null && patientPortion > 0 && (
                                              <Typography style={{ fontSize: 11, color: '#6A1B9A' }}>
                                                Patient: ${patientPortion.toFixed(2)}
                                              </Typography>
                                            )}
                                          </Box>
                                        </Box>

                                        <Box style={{ display: 'flex', gap: 'clamp(6px, 0.52vw, 8px)', flexWrap: 'wrap', marginTop: 'clamp(8px, 0.78vw, 12px)' }}>
                                          <Chip
                                            label={status}
                                            size="small"
                                            style={{
                                              backgroundColor: status === 'paid' ? '#d4edda' : 
                                                              status === 'sent' || status === 'reopened' || status === 'viewed' || status === 'accepted' ? '#cce5ff' :
                                                              status === 'draft' ? '#fff3cd' : '#e0e0e0',
                                              color: status === 'paid' ? '#155724' :
                                                     status === 'sent' || status === 'reopened' || status === 'viewed' || status === 'accepted' ? '#004085' :
                                                     status === 'draft' ? '#856404' : '#666666',
                                              textTransform: 'capitalize',
                                            }}
                                          />
                                        </Box>

                                        {invoice.due_date && (
                                          <Box style={{ marginTop: 'clamp(8px, 0.78vw, 12px)', paddingTop: 'clamp(8px, 0.78vw, 12px)', borderTop: '1px solid #f0f0f0' }}>
                                            <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666' }}>
                                              <strong>Due Date:</strong> {new Date(invoice.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                            </Typography>
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                              </>
                            )}
                                </>
                              );
                            })()}
                          </Box>
                        </Collapse>

                        {/* Divider between referral info and policy fields */}
                        <Divider style={{ margin: 'clamp(12px, 1.04vw, 16px) 0' }} />
                        <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 'clamp(12px, 1.04vw, 16px)', fontSize: 'clamp(11px, 0.85vw, 14px)' }}>
                          Policy Information
                        </Typography>

                        {/* Policy Detail Fields - Grid inside the card */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Policy Number"
                              value={selectedReferral?.policy_number || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('policy_number', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Referral Letter ID"
                              value={selectedReferral?.referral_id || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('referral_id', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Member ID"
                              value={selectedReferral?.member_id || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('member_id', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Group Number"
                              value={selectedReferral?.group_number || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('group_number', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Approved Treatments"
                              type="number"
                              value={selectedReferral?.approved_treatments ?? ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('approved_treatments', e.target.value ? parseInt(e.target.value) : '')}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Approved Amount ($)"
                              type="number"
                              value={selectedReferral?.approved_amount ?? ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('approved_amount', e.target.value ? parseFloat(e.target.value) : '')}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Valid From"
                              type="date"
                              value={selectedReferral?.valid_from || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('valid_from', e.target.value)}
                              variant="outlined"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Valid Until"
                              type="date"
                              value={selectedReferral?.valid_until || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('valid_until', e.target.value)}
                              variant="outlined"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Referral Notes"
                              value={currentIns.referralNotes}
                              onChange={(e) => updateCurrentInsurance('referralNotes', e.target.value)}
                              variant="outlined"
                              multiline
                              rows={3}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </>
                )}
                {!selectedReferral && (
                  <Grid item xs={12}>
                    <Typography style={{ color: '#999999', fontStyle: 'italic', textAlign: 'center', padding: 'clamp(16px, 1.3vw, 20px) 0' }}>
                      Select a referral letter to view and edit policy details
                    </Typography>
                  </Grid>
                )}
              </Grid>

              
            </>
          )}
          <Divider style={{ margin: 'clamp(16px, 1.3vw, 20px) 0' }} />
          <CardContent style={{ padding: 0 }}>
            <Button
              className={classes.Button}
              variant="contained"
              onClick={currentIns.isPendingReview ? handleApprovePendingInsuranceBilling : handleSave}
              disabled={isSaving || !showInsuranceFields || isPolicySaveBlocked || (currentIns.isPendingReview && (!insurancePolicyConfirmed || !referralLetterConfirmed))}
              fullWidth
            >
              {isSaving
                ? (currentIns.isPendingReview ? 'Approving...' : 'Saving...')
                : currentIns.isPendingReview
                  ? `Approve Billing ${insuranceRecords.length > 0 ? `(Tab ${currentTabIndex + 1})` : ''}`
                  : `Save Insurance Details ${insuranceRecords.length > 0 ? `(Tab ${currentTabIndex + 1})` : ''}`}
            </Button>
          </CardContent>
        </CardContent>
      </Card>

      <Dialog
        open={documentQrOpen}
        onClose={() => setDocumentQrOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <DialogTitle style={{ position: 'relative', paddingRight: 48, color: '#002D55', fontWeight: 600 }}>
          <span>Scan to upload {documentQrConfig.title}</span>
          <IconButton
            onClick={() => setDocumentQrOpen(false)}
            size="small"
            style={{ position: 'absolute', top: 8, right: 8, padding: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ backgroundColor: '#f7faff' }}>
          <Typography style={{ color: '#666', marginBottom: 16 }}>
            Use this QR on a phone to open the current patient context, then upload a photo or PDF.
          </Typography>
          <Box style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
            <QRCodeSVG value={buildDocumentCaptureUrl(documentQrConfig.target, documentQrConfig.target === 'referral' ? selectedReferral : null)} size={220} />
          </Box>
          <Typography style={{ color: '#002D55', fontSize: 12 }}>
            Patient: {selectedPatient?.display_name || patientId || 'Unknown'}
          </Typography>
          <Typography style={{ color: '#002D55', fontSize: 12 }}>
            Insurance: {currentIns.provider || 'Current insurance'}
          </Typography>
          {documentQrConfig.target === 'referral' && (
            <Typography style={{ color: '#002D55', fontSize: 12 }}>
              Referral: {selectedReferral?.referral_id || selectedReferral?.title || 'Selected referral'}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDocumentQrOpen(false)} className={classes.closeIconButton}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </form>
  );
};

SelectedPatientInsurance.propTypes = {
  className: PropTypes.string,
  selectedPatient: PropTypes.object,
  treatments: PropTypes.array,
  appointments: PropTypes.array,
  selectedTreatmentId: PropTypes.string,
  onTreatmentChange: PropTypes.func,
  headerTabs: PropTypes.node,
  headerTitle: PropTypes.node,
};

export default SelectedPatientInsurance;
